<template>
  <div class="factory_maintenance">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工厂维护信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="search_btn">
        <el-button type="primary" size="mini" @click="addFactoryMaintenance(1)"
          >新增工厂信息</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        highlight-current-row
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column label="生产厂名称" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_name
          }}</template>
        </el-table-column>
        <el-table-column label="生产厂地址" align="center">
          <template slot-scope="scope">{{
            scope.row.business_address
          }}</template>
        </el-table-column>
        <el-table-column label="邮编" align="center">
          <template slot-scope="scope">{{
            scope.row.email
          }}</template> </el-table-column
        ><el-table-column label="联系人" align="center">
          <template slot-scope="scope">{{ scope.row.contacts }}</template>
        </el-table-column>
        <el-table-column label="联系电话" align="center">
          <template slot-scope="scope">{{ scope.row.phone }}</template>
        </el-table-column>
        <!-- <el-table-column label="联系人手机" align="center">
          <template slot-scope="scope">{{ scope.row.phone }}</template>
        </el-table-column> -->
        <el-table-column label="修改时间" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.row.utime }} -->
            <span v-if="scope.row.utime">{{
              scope.row.utime | formatDate(scope.row.utime)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <span class="look" @click="addFactoryMaintenance(3, scope.row)"
              >查看</span
            >
            <span class="look" @click="addFactoryMaintenance(2, scope.row)"
              >修改</span
            >
            <span class="look" @click="deleteFactoryMaintenance(scope.row)"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="npage"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  httpEnterpriseList,
  httpEnterpriseDelete,
} from "../../utils/factorymaintenance";
import { formatDate } from "../../filters/filters.js";
export default {
  data() {
    return {
      npage: 1, //当前页
      pagesize: 10, //每页显示条数
      total: 0, //总条数
      form: {
        company: "",
      },
      tableData: [],
    };
  },
  methods: {
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this._httpEnterpriseList(this.npage, this.pagesize);
    },
    handleCurrentChange(val) {
      this.npage = val;
      this._httpEnterpriseList(this.npage, this.pagesize);
    },
    //新增/修改/查看工厂信息
    addFactoryMaintenance(type, row) {
      if (type == 1) {
        this.$router.push({
          path: "/addFactoryMaintenance",
          query: { type: type },
        });
      } else {
        this.$router.push({
          path: "/addFactoryMaintenance",
          query: { type: type, id: row.id },
        });
      }
    },
    //删除
    deleteFactoryMaintenance(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this._httpEnterpriseDelete(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //工厂信息列表
    _httpEnterpriseList(page, pagesize) {
      httpEnterpriseList(page, pagesize).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          // console.log(data);
          this.total = data.data.total;
          this.tableData = data.data.list;
        } else {
          this.$message(data.msg);
        }
      });
    },
    //删除工厂信息
    _httpEnterpriseDelete(template) {
      httpEnterpriseDelete(template).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this._httpEnterpriseList();
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpEnterpriseList(this.npage, this.pagesize);
  },
};
</script>

<style lang="scss" scoped>
.factory_maintenance {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    .search {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .search_son {
        display: flex;
        margin-right: 10px;
        width: 200px;
        margin-bottom: 5px;
        .input,
        .select {
          display: inline-block;
          height: 28px;
          line-height: 28px;
          width: 100px;
        }
        &.time {
          width: 300px;
        }
        &.btn {
          width: 56px;
        }
        i {
          font-size: 24px;
          line-height: 30px;
          cursor: pointer;
        }
        &.refresh {
          line-height: 30px;
        }
      }
    }
    .search_btn {
      margin: 10px 0;
    }
    .look {
      color: #62b3ff;
      cursor: pointer;
      margin: 0 5px;
    }
    .page_footer {
      display: flex;
      justify-content: flex-end;
      margin: 20px;
    }
    /deep/ .el-table th {
      background-color: #f2f6fc !important;
    }
  }
}
</style>